import { ref, query, equalTo, orderByChild } from "firebase/database";
import { useContext, useEffect, useMemo, useState } from "react";
import { useList, useListVals } from "react-firebase-hooks/database";

import { database } from 'lib/firebase'
import { useGroup } from "./useGroup";
import { useBroadcast } from "./useBroadcast";
import { DataContext } from "contexts/DataContext";

export const useLocation = ({user}) => {

  const { locations } = useContext(DataContext)
  const [locationItems, loadingLoc, errorLoc, refreshLoc] = locations;
  
  const [groups, loadingGroup, errorGroup, refreshGroup] = useGroup({user})
  const [broadcasts, loadingBrd, errorBrd, refreshBrd] = useBroadcast({user})
  
  return [locationItems.map(loc => {
    if (loc.broadcastId) loc.broadcast = broadcasts.find(br => br.id === loc.broadcastId)
    if (loc.groupId) loc.group = groups.find(gr => gr.id === loc.groupId)
    return loc
  }), loadingLoc || loadingGroup || loadingBrd, errorLoc || errorGroup || errorBrd, () => {
    refreshLoc()
    refreshGroup()
    refreshBrd()
  }];
};
